export const GENERIC_ERR_MSG = 'Something went wrong!';
export const EXISTING_PLAN_ERR_MSG = "New plan can't be same as current plan.";
